import UserActionError from '@/interfaces/errors/userAction';
export const createImageCopyError = (prefix, err) => {
  const actionErr = new UserActionError(`${prefix} copy image to clipboard: ${err}`);
  actionErr.userMessage = 'There was an issue copying your image to clipboard, please try again or contact us for help.';
  return actionErr;
};